module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/packages/yofoui/customized/sharemodalx/assets/timeline.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/customized/sharemodalx/assets/timeline.png
// module id = 1725
// module chunks = 367